import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

const MarketingFooter = forwardRef<HTMLElement>((props, ref) => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { label: 'Features', href: '/#features' },
      { label: 'How It Works', href: '/#how-it-works' },
      { label: 'Pricing', href: '/pricing' },
    ],
    company: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
      { label: 'Careers', href: '/employment' },
    ],
    legal: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'FERPA Compliance', href: '/ferpa' },
      { label: 'SOC 2 Readiness', href: '/soc2' },
    ],
  };

  return (
    <footer ref={ref} className="border-t border-border/50 bg-background/50 backdrop-blur-sm">
      <div className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4">
              <Logo linkTo="/" size="sm" />
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              AI-powered sales training for professionals and students.
            </p>
          </div>

          {/* Product Links */}
          <div>
            <p className="font-display font-semibold text-sm mb-4" role="heading" aria-level={3}>Product</p>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.href}
                    className="text-muted-foreground text-sm hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <p className="font-display font-semibold text-sm mb-4" role="heading" aria-level={3}>Company</p>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.href}
                    className="text-muted-foreground text-sm hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <p className="font-display font-semibold text-sm mb-4" role="heading" aria-level={3}>Legal</p>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link 
                    to={link.href}
                    className="text-muted-foreground text-sm hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-border/50 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {currentYear} BigE Sales Coach ®. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-muted-foreground/60 text-xs">
              Designed for sales professionals and students
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
});

MarketingFooter.displayName = 'MarketingFooter';

export default MarketingFooter;
